import { render, staticRenderFns } from "./BannerWebinar.vue?vue&type=template&id=2046d08e&scoped=true&"
import script from "./BannerWebinar.vue?vue&type=script&lang=js&"
export * from "./BannerWebinar.vue?vue&type=script&lang=js&"
import style0 from "./BannerWebinar.vue?vue&type=style&index=0&id=2046d08e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2046d08e",
  null
  
)

export default component.exports